import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
} from '@backstage/core-plugin-api';

import { createRootRouteRefsPair } from '@spotify/confidence-core-react';

export enum RoutesIds {
  insights = 'insights',
}

enum ExternalRoutesIds {
  surface = 'surface',
}

// root route
export const [insightsRouteImplRef, insightsRouteRef] = createRootRouteRefsPair(
  { id: RoutesIds.insights },
);

export const rootRouteRef = insightsRouteImplRef;

// external routes to other plugins
export const surfaceRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.surface,
  params: ['id'],
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  insights: insightsRouteImplRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // sub-routes within the plugin
  insights: insightsRouteRef,

  // external routes to other plugins
  surface: surfaceRouteRef,
} satisfies Record<RoutesIds, ExternalRouteRef> &
  Record<ExternalRoutesIds, ExternalRouteRef>;
